const en = {
  CREATE: 'Create',
  SAVE: 'Save',
  UNLOCK_MORE_LESSONS: 'Unlock more lessons',
  USER_PROFILE: {
    USER_PASSWORD: 'User password',
    UPDATE_PASSWORD_HERE: 'Update your password here',
    USER_PROFILE: 'User profile',
    UPDATE_USER_PROFILE: 'Update your profile here',
  },
  CORPORATE_CUSTOMER: {
    TITLE: 'Corporate Customers',
  },
  NOTIFICATION: {
    TITLE: 'Notifications',
    MARK_AS_READ: 'Mark all as read',
    NO_NOTI: 'No more notifications',
    LOAD_MORE: 'Load more',
    VIEW_ALL: 'View all',
    UNREAD: 'Unread',
    DETAIL_TITLE: 'Notification details',
    DETAIL_BACK: 'Back to list',
    DETAIL_NOT_FOUND: 'This notification could not be found.',
    DETAIL_NO_BODY: 'No additional content.',
  },
  CONSULTATION_FORM: {
    TITLE: 'Become a Full Stack Data Scientist Today',
    FIELDS: {
      NAME: {
        LABEL: 'Name',
        PLACEHOLDER: 'Enter your name',
        ERROR: 'Name must be at least 2 characters',
      },
      EMAIL: {
        LABEL: 'Email',
        PLACEHOLDER: 'Your email',
        ERROR: 'Invalid email',
      },
      PHONE: {
        LABEL: 'Phone number',
        PLACEHOLDER: 'Enter phone number',
        ERROR: 'Phone number must be 10 digits',
      },
      MESSAGE: {
        LABEL: 'Message',
        PLACEHOLDER: 'Enter your message',
        ERROR: 'Message must be at least 10 characters',
      },
    },
    SUBMIT: {
      BUTTON: 'Get consultation',
      SENDING: 'Sending...',
      SUCCESS: 'Thank you! We will contact you soon.',
      ERROR: 'An error occurred. Please try again later.',
    },
    DIVIDER: 'or',
    FACEBOOK: 'Contact via Facebook',
  },
  COURSE_MODULE: {
    TAGS: {
      SHOW_MORE: 'Show more',
      SHOW_LESS: 'Show less',
      COUNT_LABEL: (count: number) => `+${count} more`,
    },
    OVERVIEW: 'Course overview',
    INFORMATION: {
      TITLE: 'Information',
      FINAL_PROJECT: 'Final project',
      LAB_NUMBER: 'Number of labs',
      SCHEDULE: 'Schedule',
      TOTAL_DURATION: 'Estimated Lectures Completion Time',
      PROJECT_DURATION: 'Estimated Graduation Project Completion Time',
      ACCESS_DURATION: 'Access Duration',
      FORMAT: 'Format',
    },
    FORMAT: {
      TITLE: 'Format',
      LEARNING_FORMAT: {
        TITLE: 'Learning Format',
        PRE_RECORDED: 'Pre-recorded videos',
        ONLINE: 'Online learning via pre-recorded videos (Students can also review live recordings)',
        SUPPORT: 'Debug support via Discord or direct Zoom calls',
      },
      PROMOTION: {
        TITLE: 'Promotion',
        DISCOUNT: '15% tuition fee discount',
      },
    },
  },
  FEATURE_GLASS: {
    TITLE: 'Why choose FSDS?',
    CARDS: {
      PIONEER: {
        TITLE: 'Pioneer in Full Stack Data Scientist Training',
        DESCRIPTION:
          'The only program in Vietnam that helps you master the entire process from Data Engineering, Model Development, Model Deployment, and Analytics.',
      },
      PRACTICAL: {
        TITLE: 'Practical Knowledge - Aligned with Business Needs',
        DESCRIPTION:
          'Learning by doing: Combining theory, in-depth labs and final projects simulating real-world projects.',
      },
      DEMO_DAY: {
        TITLE: 'Demo Day - Project Review & 1-1 Career Guidance',
        DESCRIPTION:
          'Present projects to expert panel, receive direct feedback and personal development advice from lecturers and mentors.',
      },
      BEYOND_ALGO: {
        TITLE: 'Data Science Beyond Algorithms',
        DESCRIPTION:
          'Curriculum integrates Domain Knowledge, helping you effectively apply AI/ML to specific industries.',
      },
      INSTRUCTORS: {
        TITLE: 'Professional Instructors from Big Tech',
        DESCRIPTION:
          'Learn from experts with at least 5 years of teaching experience, having worked at leading companies.',
      },
      COMMUNITY: {
        TITLE: 'FSDS Community - Connect & Grow Your Career',
        DESCRIPTION:
          'Join the FSDS network to learn from experts, get the latest updates on exciting job opportunities, including non-public positions.',
      },
    },
  },
  BILLING: {
    SKELETON: {
      TITLE: 'Billing',
      SUBTITLE: 'Manage your billing and payment details.',
      PLAN: 'Monthly',
    },
    HISTORY: {
      TITLE: 'Billing history',
      ERROR: 'Error loading data',
    },
    DATA: {
      NO_INVOICE: {
        TITLE: 'No invoice found',
        DESCRIPTION:
          'It looks like this space is empty at the moment. Perhaps you could make a purchase to add something here?',
      },
      ERROR: {
        TITLE: 'Error Loading Billing Information',
        DEFAULT_MESSAGE: 'Failed to load billing information. Please try again later.',
      },
      NO_DATA: 'No billing information available.',
      SECTION: {
        TITLE: 'Your latest payment',
        SUBTITLE: 'Manage your subscription and payment details.',
        POPULAR_PLAN: 'Our most popular plan for individuals.',
        SUBSCRIPTION_STATUS: 'Subscription Status',
        TIME_REMAINING: '{days}d {hours}h {minutes}m remaining',
        RENEWAL_MESSAGE: 'Your subscription will {action} on {date}',
      },
    },
    PAGE: {
      TITLE: 'Your Payment',
      SUBTITLE: 'Manage your billing and payment details.',
      LABEL: 'Plans & Billing',
      GO_TO_PRICING: 'Go to pricing plan',
    },
    CANCEL_SUBSCRIPTION: {
      BUTTON: 'Cancel Subscription',
      CONFIRM_TITLE: 'Cancel Subscription',
      CONFIRM_DESCRIPTION: 'Are you sure you want to cancel your subscription? This action cannot be undone.',
      REASON_LABEL: 'Reason for cancellation (Optional)',
      REASON_PLACEHOLDER: 'Tell us why you are canceling...',
      CONFIRM_BUTTON: 'Yes, cancel subscription',
      CANCEL_BUTTON: 'No, keep my subscription',
      SUCCESS_MESSAGE: 'Your subscription has been canceled successfully.',
      ERROR_MESSAGE: 'Failed to cancel subscription. Please try again.',
    },
  },
  CHECKOUT: {
    TITLE: 'Checkout',
    ORDER_SUMMARY: 'Order Summary',
    SUBTOTAL: 'Subtotal',
    TOTAL: 'Total',
    PAYMENT_METHOD: 'Payment Method',
    PROCESSING: 'Processing...',
    PAYMENT_SUCCESS: 'Successful payment!',
    PAYMENT_ERROR: 'There was an error processing your payment. Please try again.',
    SUCCESS_TOAST_TITLE: 'Success',
    SUCCESS_PAGE: {
      TITLE: 'Payment Successful',
      HEADING: 'Payment Successful!',
      MESSAGE:
        'Thank you for your purchase. Your payment has been processed successfully. Please check out your email for more detail information.',
      RETURN_HOME: 'Return to Home',
      ACCESS_COURSES: 'Go to my courses',
    },
    FAILED_PAGE: {
      TITLE: 'Payment Failed',
      HEADING: 'Payment Failed',
      TRY_AGAIN: 'Try Again',
      RETURN_HOME: 'Return to Home',
    },
    FREE_ITEM: 'Free',
    DISCOUNT_FIXED: 'Discount fixed',
  },
  FOOTER: {
    SECTIONS: {
      COURSES: 'Courses',
      COMMUNITY: 'Community',
      PLAN: 'Plan',
    },
    ITEMS: {
      MLOPS: 'MLOps',
      MLOPS_1: 'MLOps 1',
      MLOPS_2: 'MLOps 2',
      MLOPS_3: 'MLOps 3',
      MLOPS_4: 'MLOps 4',
      IGDS: 'IGDS',
      CDA: 'CDA',
      BLOG: 'Blog',
      WEBINARS: 'Webinars',
      SURVEY: 'Survey',
      PRICING: 'Pricing',
      HALL_OF_FAME: 'Hall of Fame',
    },
    COPYRIGHT: '© {year} {siteName}.',
  },
  HALL_OF_FAME_SECTION: {
    TITLE: 'Hall of Fame',
    DESCRIPTION:
      "A platform to showcase our students' progress, where we preserve their proud achievements, attractive offers, and passionate projects.",
    VIEW_ALL: 'View all',
  },
  SURVEY: {
    HERO: {
      TITLE: 'Course Survey',
      DESCRIPTION:
        'Our exclusive curriculum combines <b>Business Intelligence</b> and <b>Machine Learning</b>. Equip yourself with the knowledge and skills needed to become a data analytics expert with <b>algorithmic thinking</b>, <b>data storytelling capabilities</b>, and <b>technical proficiency</b> in finance and marketing fields.',
      GET_CONSULTATION: 'Get Consultation',
    },
    TITLE: 'Course Survey',
    DESCRIPTION: 'Help us improve our courses by providing your valuable feedback',
    FORM: {
      HEADER: {
        TITLE: 'Survey',
        SUBTITLE: 'We would love to hear from you. Please fill out this form.',
      },
      LABELS: {
        COURSE: 'Course',
        COURSE_PLACEHOLDER: 'Enter course name',
        REVIEW: 'Review',
        REVIEW_PLACEHOLDER: 'Write your review here',
        EMAIL: 'Email',
        EMAIL_PLACEHOLDER: 'Enter your email',
        IMPROVEMENT: 'Improvement (Optional)',
        IMPROVEMENT_PLACEHOLDER: 'Suggest improvements',
        IMPROVEMENT_DESCRIPTION: 'Optional: Suggest any improvements for the course',
      },
      SUBMIT: 'Submit Survey',
      SUCCESS: {
        TITLE: 'Survey sent successfully',
        DESCRIPTION: 'Thank you for your feedback!',
      },
      ERROR: {
        TITLE: 'Error sending survey',
        DESCRIPTION: 'An error occurred while sending your survey. Please try again.',
      },
      VALIDATION: {
        COURSE_REQUIRED: 'Course name is required',
        REVIEW_MIN_LENGTH: 'Review must be at least 10 characters long',
        EMAIL_INVALID: 'Invalid email address',
      },
      NAME: 'Full Name',
      EMAIL: 'Email Address',
      COURSE: 'Course Name',
      RATING: 'Course Rating',
      FEEDBACK: 'Your Feedback',
    },
  },
  HEADER: {
    COURSE: 'Courses',
    HALL_OF_FAME: 'Hall of Fame',
    LOGIN: 'Sign In',
    STUDENT_THOUGHTS: 'Students thoughts',
    INSTRUCTORS: 'Instructors',
    FAQ: 'FAQ',
    CAREER: 'Career',
  },
  MAIN: {
    INTRODUCTION: {
      HEADING_1: '💻 Learn Data Science from an Engineering Perspective',
      HEADING_2: 'Become a <span class="text-white">Full Stack <br/> Data Scientist</span>',
      HEADING_3:
        'FSDS offers a comprehensive curriculum covering <b>algorithms, analytical thinking, domain knowledge</b> to <b>engineering</b>, helping you build a solid foundation to solve real-world problems.',
      HEADING_4: 'Contact now',
      HEADING_5: 'Buy now',
      HEADING_6: 'Learn now',
      HEADING_7: 'Coming soon',
    },
    BODY: {
      HEADING_1: 'FSDS Courses',
      HEADING_2: 'Start a new career in just 6 months.',
      COURSE: {
        DETAIL: 'More detail',
        DETAIL_COURSE: 'View detail',
      },
      COURSE_VI: {
        1: {
          TITLE: 'MLOps Course',
          DESCRIPTION:
            'Learn how to <b>automate</b>, <b>deploy</b>, and <b>monitor</b> machine learning models at scale using modern <b>tools</b> and <b>frameworks</b>.',
        },
        2: {
          TITLE: 'Comprehensive Data Analytics (CDA) Course',
          DESCRIPTION:
            'Develop skills in <b>business intelligence</b>, <b>predictive analytics</b>, and <b>data storytelling</b>.',
        },
        3: {
          TITLE: 'Industrial-Grade Data Science (IGDS) Course',
          DESCRIPTION:
            'Dive deep into <b>machine learning</b>, <b>deep learning</b>, and <b>practical applications</b> in each field.',
        },
      },
      COURSE_EN: {
        1: {
          TITLE: 'MLOps 1',
          DESCRIPTION:
            'Learn how to <b>automate</b>, <b>deploy</b>, and <b>monitor</b> machine learning models at scale using modern <b>tools</b> and <b>frameworks</b>.',
        },
        2: {
          TITLE: 'MLOps 2',
          DESCRIPTION:
            'Learn how to <b>automate</b>, <b>deploy</b>, and <b>monitor</b> machine learning models at scale using modern <b>tools</b> and <b>frameworks</b>.',
        },
        3: {
          TITLE: 'MLOps 3',
          DESCRIPTION:
            'Learn how to <b>automate</b>, <b>deploy</b>, and <b>monitor</b> machine learning models at scale using modern <b>tools</b> and <b>frameworks</b>.',
        },
        4: {
          TITLE: 'MLOps 4',
          DESCRIPTION:
            'Learn how to <b>automate</b>, <b>deploy</b>, and <b>monitor</b> machine learning models at scale using modern <b>tools</b> and <b>frameworks</b>.',
        },
        DETAIL: 'More detail',
      },
      HEADING_3: 'Why should you choose FSDS?',
      FEATURES: {
        1: {
          TITLE: 'Algorithms',
          DESCRIPTION: 'Build a solid foundation in algorithms from basic to advanced levels.',
        },
        2: {
          TITLE: 'Analytical Thinking',
          DESCRIPTION: 'Develop analytical thinking and solve real-world problems from industry experts.',
        },
        3: {
          TITLE: 'Practical Applications',
          DESCRIPTION:
            'Apply with real-world datasets and problems from sectors such as banking, e-commerce, transportation, publishing, and marketing.',
        },
        4: {
          TITLE: 'Engineering',
          DESCRIPTION: 'Build and deploy efficient, high-load systems and technical infrastructure.',
        },
      },
      HEADING_4: 'Learn theory alongside practice!',
      HEADING_5:
        'FSDS understands that a solid theoretical foundation is crucial, but to become a true Data Scientist, students need to familiarize themselves with <b>real-world tools</b> and <b>hands-on practice</b> on actual projects.',
      HEADING_6: 'What our students say about FSDS',
      FEEDBACK_BUTTON: {
        EXPAND: '❤️ View more',
        COLLAPSE: '❤️ Collapse',
      },
      HEADING_7: 'Where our students come from?',
      HEADING_8: 'Sample lecture',
      HEADING_9: 'Become a Full Stack Data Scientist now',
      CONTACT_BUTTON: 'Contact now',
      HEADING_10: 'Instructors',
      HEADING_11: 'FAQ',
      FAQ: {
        1: {
          QUESTION: 'Will I receive a certificate after completing the course?',
          ANSWER:
            'Yes, you will receive a certificate after completing the final project. It is issued once, valid for a lifetime, and never expires. Please note that the certificate is only awarded if the project is approved by the instructor.',
        },
        2: {
          QUESTION: 'Can I share or download the course content?',
          ANSWER:
            'The content owned by Full Stack Data Science is for personal, non-commercial use only. Sharing content with others is not permitted and is illegal.',
        },
        3: {
          QUESTION: 'What are the system requirements for the course?',
          ANSWER:
            'To ensure the best learning experience, we recommend using a computer with at least 16GB RAM and 150GB of storage (preferably an SSD). Throughout the course, we will be using Ubuntu 22.04; however, version 20.04 is also a suitable alternative if already installed. For MacBook users, Ubuntu installation is not required, but having a separate Ubuntu-based system would be ideal. Please avoid using outdated processors (e.g., Intel i3 chips from 10 years ago) to ensure smooth and efficient performance during the course.',
        },
        4: {
          QUESTION: 'Does FSDS require any math prerequisites?',
          ANSWER:
            'No. FSDS courses focus on engineering and large-scale system deployment. Relevant mathematical concepts are covered in FSDS classes to help students understand algorithms and how to implement them.',
        },
      },
    },
    ROADMAP: {
      HEADING: "Full Stack Data Scientist Roadmap <br /> by <span class='text-primary'>FSDS</span>",
    },
    COURSE: {
      HEADING: 'FSDS Courses',
      TOTAL_DURATION: 'Estimated Lectures Completion Time',
      PROJECT_DURATION: 'Estimated Graduation Project Completion Time',
      ACCESS_DURATION: 'Access Duration',
      MONTH: 'months',
      DETAIL: {
        MLOPS_1: {
          TITLE: 'Building Effective ML Systems',
          TITLE_2: 'Essential Elements to Conquer <br /> Data Science',
          BODY: {
            TITLE: 'Advanced Projects and Exercises',
            DESCRIPTION: 'Each exercise, test, and project is designed around real-world problems.',
            DESCRIPTION_1: 'Build OCR Deployment using Ansible and Terraform',
            DESCRIPTION_2: 'Develop a streaming data pipeline with Flink',
            DESCRIPTION_3: 'Optimize the inference server with KServe',
            DESCRIPTION_4: 'Manage data quality with Great Expectations',
          },
          VIEW_LECTURE: 'View syllabus',
          DESCRIPTION:
            'Become an MLOps expert with <b>technical thinking</b>, <b>model deployment</b>, and <b>building sustainable ML systems</b> on advanced platforms like <b>Kubernetes</b>, <b>Terraform</b>, <b>Kubeflow</b>, and <b>Airflow</b>.',
        },
      },
    },
    INSTRUCTORS: {
      JOB_TITLE: 'Instructor - ',
    },
  },
  COURSE: {
    MY_COURSE: 'My Courses',
    LAST_ACCESS_DATE: 'Course access expiry',
    TAKE_FINAL_EXAM: 'Take the final exam',
    HOMEWORK: 'Homework',
    COURSE_DISCUSSION: 'Instructors Discussion',
    DISCUSSION: 'Discussion',
    VIEW_ALL: 'View all',
    NO_TOPIC: 'No topics',
    CLASS_PROHIBITED:
      'Unfortunately, you are unable to access this course. Please verify your payment details for the course.',
    FREE_COURSES: 'Free Courses',
    TRY_FREE: 'Try for Free',
    NO_COURSES_YET: "You haven't joined any courses yet",
    SEARCH_PLACEHOLDER: 'Search courses by name...',
    NO_COURSES_MATCH_SEARCH: 'No courses match your search',
    CLEAR_SEARCH: 'Clear search',
    GET_STARTED: 'Purchase a course to start learning',
    NO_FREE_COURSES: 'No free courses available at the moment',
    DURATION: 'Duration',
    MONTH: 'month',
    MAX_PROJECT_SUBMISSION: {
      TEXT_1: 'Each final project can be submitted up to',
      TEXT_2: 'times. You have',
      TEXT_3: 'remaining',
      TEXT_4: 'You have exceeded allowed submission times',
      TEXT_5: 'times',
      TEXT_6: 'Please contact the instructor for more detail',
    },
    FINAL_PROJECT: {
      TEXT_1: 'Submit final project',
      TEXT_2: 'Please provide github repository link of the final project.',
      TEXT_3: 'Make sure your repository is on public mode or you already give the instructor access permission.',
    },
  },
  COURSE_UI: {
    OVERVIEW: 'Overview',
    LESSON: 'Lesson',
    LESSONS_COUNT: (count: number) => `${count} lessons`,
    NO_DESCRIPTION: 'No course description available',
    NO_LESSONS: 'No lessons available',
    EDIT_COURSE: 'Edit Course',
    VIEW_RESOURCE: 'View resource',
    QUESTION_OF: (current: number, total: number) => `Question ${current} of ${total}`,
    NEW_ATTEMPT: 'New Attempt',
    SUBMIT_QUIZ: 'Submit Quiz',
    SUBMIT_ASSIGNMENT: 'Submit Assignment',
    RETRY_ASSIGNMENT: 'Retry',
    SUBMITTING: 'Submitting...',
    QUIZ_SUBMITTED: 'Quiz Submitted Successfully!',
    ASSIGNMENT_SUBMITTED: 'Assignment Submitted Successfully!',
    PASSED: 'PASSED',
    FAILED: 'FAILED',
    SHOW_EXPLANATIONS: 'Show Explanations',
    QUIZ_EXPLANATIONS: 'Quiz Explanations',
    YOUR_CORRECT_ANSWERS: 'Your correct answer(s):',
    YOUR_WRONG_ANSWERS: 'Your wrong answer(s):',
    EXPLANATION: 'Explanation',
    OPEN_EXPLANATION: 'Open',
    NO_EXPLANATION: 'No explanation provided.',
    NO_QUIZ_QUESTIONS: 'No questions available for this quiz',
    OVERDUE_BY: 'Overdue by',
    TIME_REMAINING: 'Time remaining',
    DUE_AT: 'Due at:',
    DOWNLOAD_ASSIGNMENT: 'Download Assignment',
    GRADER_FILES: 'Grader Files:',
    GRADER_FILE: (n: number) => `Grader File ${n}`,
    NO_ASSIGNMENT_CONTENT: 'No content available for this assignment.',
    NO_TEXT_CONTENT: 'No content available for this text material.',
    NO_VIDEO: 'No video available for this course',
    SELECT_LESSON: 'Select a lesson to start watching',
    VIDEO_URL_UNAVAILABLE: 'Video URL not available for this lesson',
    PREMIUM_LESSON:
      'This lesson is part of our premium course. Enroll now to access all content, discussions, and resources.',
    PREMIUM_CONTENT: 'Premium Content',
    ENROLL_NOW: 'Enroll Now - $99',
    ADMIN_ACCESS: 'Admin Access',
    ADMIN_ACCESS_DESC: 'You have full access to all course content as an administrator.',
    MARK_VIDEO_FAILED: 'Failed to mark video as completed. Please try again.',
    MARK_LESSON_FAILED: 'Failed to mark lesson as completed. Please try again.',
    MARK_QUIZ_FAILED: 'Failed to mark quiz as completed. Please try again.',
    SUBMIT_QUIZ_FAILED: 'Failed to submit quiz. Please try again.',
    FULLSCREEN_FAILED: 'Unable to toggle fullscreen mode.',
    DOWNLOAD_FAILED: 'Failed to download assignment. Please try again.',
    QUIZ_PASS_TOAST: (score: number, passingScore: number) =>
      `🎉 Congratulations! You scored ${score}% and passed! (Passing score: ${passingScore}%)`,
    QUIZ_FAIL_TOAST: (score: number, passingScore: number) =>
      `You scored ${score}%. You need ${passingScore}% to pass. Please review and try again.`,
    QUIZ_ANSWERED: (correct: number, total: number) =>
      `You answered ${correct} out of ${total} questions correctly.`,
    PASSING_SCORE_REQUIRED: 'Passing score required:',
    MORE_CORRECT_NEEDED: (count: number) =>
      ` (You need ${count} more correct answer${count === 1 ? '' : 's'})`,
    QUIZ_PASS_HINT: '🎉 Congratulations! You can now review the correct answers highlighted in green below.',
    QUIZ_FAIL_HINT: '📚 Please review the explanations below to understand the correct answers and try again.',
    BACK_TO_RESULTS: 'Back to Results',
    DELETE_SELECTED: (count: number) => `Delete (${count})`,
    VIEW_COURSE_TITLE: 'View course',
    VIEW_COURSE_SUBTITLE: 'Review course content, lessons, and discussions',
    BACK_TO_COURSES: 'Back to courses',
    BACK_TO_COURSE: 'Back to course',
    CREATE_COURSE: 'Create new course',
    EDIT_COURSE_TITLE: 'Edit course',
    CREATE_COURSE_SUBTITLE: 'Set up a new course and its modules',
    EDIT_COURSE_SUBTITLE: 'Update course details and learning content',
    SETUP_LESSON: 'Setup lesson',
    SETUP_LESSON_SUBTITLE: 'Configure lesson content and materials',
    ADD_MODULE: 'Add module',
    ADD_LESSON: 'Add lesson',
    DELETE_MODULE: 'Delete module',
    DELETE: 'Delete',
    SAVE_CHANGES: 'Save changes',
    SAVING: 'Saving...',
    COURSE_INFORMATION: 'Course information',
    NAME_OF_COURSE: 'Name of course',
    ENTER_COURSE_NAME: 'Enter name of course',
    DESCRIPTION: 'Description',
    SETTING: 'Setting',
    PUBLISH_COURSE: 'Publish course',
    FREE_COURSE: 'Free course',
    NAME_OF_MODULE: 'Name of module',
    ENTER_MODULE_NAME: 'Enter name of module',
    NO_LESSONS_YET: 'No lessons yet. Use "Add lesson" to create the first one.',
    NO_MODULES_YET: 'No modules yet. Use "Add module" to structure this course.',
    DELETE_MODULE_TITLE: 'Delete this module?',
    DELETE_LESSON_TITLE: 'Delete this lesson?',
    DELETE_CONTENT_TITLE: 'Delete this content?',
    DELETE_QUESTION_TITLE: 'Delete this question?',
    DELETE_ANSWER_TITLE: 'Delete this answer?',
    DELETE_ATTACHMENT_TITLE: 'Delete this attachment?',
    DELETE_CONFIRM_DESC: (label: string) =>
      `${label} and everything inside it will be removed.\nThis action cannot be undone`,
    DELETED: 'Deleted successfully',
    DELETE_FAILED: 'Delete failed',
    ADD_CONTENT: 'Add content',
    LESSON_INFORMATION: 'Lesson information',
    NAME_OF_LESSON: 'Name of lesson',
    ENTER_LESSON_NAME: 'Enter name of lesson',
    NO_CONTENT_YET: 'No content yet. Click "Add content" to add a video, text, or assignment.',
    CONTENT_KIND_VIDEO: 'Video',
    CONTENT_KIND_TEXT: 'Text',
    CONTENT_KIND_ASSIGNMENT: 'Assignment',
    CONTENT_KIND_QUIZ: 'Quiz',
    NAME_OF_VIDEO: 'Name of video',
    ENTER_VIDEO_NAME: 'Enter name of video',
    VIDEO_LENGTH: 'Video length',
    VIDEO_LENGTH_PLACEHOLDER: '00:00:00 (hh:mm:ss)',
    NAME_OF_TEXT: 'Name of text',
    ENTER_TEXT_NAME: 'Enter name of text',
    NAME_OF_ASSIGNMENT: 'Name of assignment',
    ENTER_ASSIGNMENT_NAME: 'Enter name of assignment',
    NAME_OF_QUIZ: 'Name of quiz',
    ENTER_QUIZ_NAME: 'Enter name of quiz',
    DELETE_ITEM_ARIA: (label: string) => `Delete ${label}`,
    PUBLISH_ITEM_ARIA: (label: string) => `Publish ${label}`,
    UNTITLED: 'Untitled',
    ATTACHMENT_LINK: 'Link',
    ATTACHMENT_DOCUMENT: 'Document',
    ADD_ATTACHMENT: 'Add attachment',
    NAME_OF_DOCUMENT: 'Name of document',
    ENTER_DOCUMENT_NAME: 'Enter name of document',
    ENTER_LINK_URL: 'Enter link URL',
    NAME_OF_LINK: 'Name of link',
    OPTIONAL: '(Optional)',
    ENTER_LINK_NAME: 'Enter name of link',
    SELECT_RESOURCE: 'Select resource',
    ADD_QUESTION: 'Add question',
    QUESTION_N: (n: number) => `Question ${n}`,
    ENTER_QUESTION: 'Enter the question',
    DELETE_QUESTION_ARIA: (n: number) => `Delete question ${n}`,
    MULTIPLE_CHOICE: 'Multiple choice',
    ANSWER_COUNT: (n: number) => `Answer (${n})`,
    ADD_ANSWER: 'Add answer',
    ANSWER_N: (n: number) => `Answer ${n}`,
    ENTER_ANSWER: 'Enter the answer',
    ANSWER_CORRECT_ARIA: (n: number) => `Answer ${n} is correct`,
    DELETE_ANSWER_ARIA: (n: number) => `Delete answer ${n}`,
    EXPLANATION_OPTIONAL: 'Explanation (Optional)',
    COURSE_TITLE_REQUIRED: 'Please enter the name of course',
    CHECK_COURSE_INFO: 'Please check the course information',
    UPLOAD_IN_PROGRESS: 'Upload in progress',
    UPLOAD_WAIT: 'Please wait until every video finishes uploading.',
    CHECK_COURSE_CONTENT: 'Please check the course content',
    COURSE_UPDATED: 'Course updated successfully',
    COURSE_CREATED: 'Course created successfully',
    UPDATE_COURSE_FAILED: 'Update course failed',
    CREATE_COURSE_FAILED: 'Create course failed',
    SOMETHING_WENT_WRONG: 'Something went wrong',
    MANAGE_STUDENTS: 'Manage students',
    MANAGE_STUDENTS_SUBTITLE: 'Manage and organize courses across the platform',
    SELECT_STUDENTS: 'Select students',
    ADD_STUDENTS: 'Add students',
    SEARCHING: 'Searching...',
    SEARCH_PLACEHOLDER: 'Searching...',
    SELECT_ALL_STUDENTS: 'Select all students on this page',
    NAME: 'Name',
    EMAIL: 'Email',
    QUIZ_PROGRESS: 'Quiz progress',
    DISCUSSION_COL: 'Discussion',
    CERTIFIED: 'Certified',
    ACTIONS: 'Actions',
    LOADING_STUDENTS: 'Loading students...',
    EMPTY_STUDENTS: 'Add a new user or try adjusting your search and filters',
    YES: 'Yes',
    NO: 'No',
    ALL: 'All',
    VIEW_DETAIL: 'View detail',
    REMOVE_STUDENT_TITLE: 'Remove this student from the course?',
    REMOVE_STUDENTS_TITLE: (count: number) => `Remove ${count} students from the course?`,
    REMOVE_STUDENT_DESC: 'This student will be removed from the course.\nYou can add them again later.',
    REMOVE_STUDENTS_DESC: 'These students will be removed from the course.\nYou can add them again later.',
    CONFIRM: 'Confirm',
    REMOVING: 'Removing...',
    STUDENTS_REMOVED: 'Students removed',
    STUDENTS_REMOVED_DESC: 'Selected students have been removed from this course.',
    COULD_NOT_REMOVE: 'Could not remove students',
    TRY_AGAIN: 'Something went wrong. Please try again.',
    STUDENTS_ADDED: 'Students added',
    STUDENTS_ADDED_DESC: 'The course student list has been updated.',
    COULD_NOT_ADD: 'Could not add students',
    NO_STUDENTS_SELECTED: 'No students selected',
    SELECT_AT_LEAST_ONE: 'Search and select at least one student.',
    SEARCH_STUDENTS_PLACEHOLDER: 'Searching name or email of students...',
    NO_MATCHING_STUDENTS: 'No matching students found.',
    ADDING: 'Adding...',
    ADD_COUNT: (count: number) => `Add (${count})`,
    CLOSE: 'Close',
    STUDENT_REPORT: 'Student report',
    STUDENT_REPORT_NAMED: (name: string) => `Student report: ${name}`,
    LOADING_STUDENT_REPORT: 'Loading student report...',
    UNABLE_LOAD_STUDENT_REPORT: 'Unable to load student report.',
    ATTENDANCE: 'Attendance',
    DISCUSSIONS_MADE: (count: number) => `Discussions made in current course: ${count}`,
    QUIZ_SCORING: 'Quiz scoring',
    AVERAGE_SCORE: (score: string) => `Average score: ${score}`,
    MARK_CERTIFIED: 'Mark as certified',
    VIEW_CERTIFICATE: 'View certificate',
    REPORT_UPDATED: 'Student report updated',
    REPORT_UPDATED_DESC: 'Certification status has been saved.',
    REPORT_UPDATE_ERROR: 'There was an error updating the student report',
    ERROR: 'Error',
    DISCUSSION_SUBTITLE: 'Share questions and ideas with classmates',
    NEW_DISCUSSION: 'New discussion',
    CREATE_TOPIC_ARIA: 'Create new discussion topic',
    DELETE_TOPIC: 'Delete Topic',
    DELETE_TOPIC_WARN: 'This action cannot be undone. The topic and all its comments will be permanently removed.',
    DELETE_TOPIC_CONFIRM:
      'Are you sure you want to delete this topic? This action cannot be undone and will permanently remove the topic and all its comments.',
    DELETING: 'Deleting...',
    DELETE_TOPIC_BTN: 'Delete Topic',
    COMMENT: 'Comment',
    CREATE_POST: 'Create post',
    EDIT_POST: 'Edit post',
    GENERAL_DISCUSSION: 'General Discussion',
    ANONYMOUS: 'Anonymous',
    SIGN_IN_TO_REACT: 'Sign in to react',
  },
  SETTING_BAR: {
    MY_COURSE: 'My courses',
    PROFILE: 'Profile',
    CHANGE_PASSWORD: 'Change password',
    COURSE_MANAGEMENT: 'Course management',
    CLASS_MANAGEMENT: 'Class management',
    USER_MANAGEMENT: 'User management',
    SANDBOX_MANAGEMENT: 'Sandbox management',
    VOUCHER_MANAGEMENT: 'Voucher management',
    BLOG_MANAGEMENT: 'Blog management',
    RESOURCE_MANGEMENT: 'Resource management',
    HALL_OF_FAME: 'Hall of Fame',
    LOGOUT: 'Log out',
    SURVEY_ADMIN: 'Surveys of user',
    SURVEY: 'Survey',
    WEBINARS_MANAGEMENT: 'Webinars management',
    BILLING: 'Billing',
    COMPANY_MANAGEMENT: 'Company management',
    JOBS: 'Job management',
    REFERRED_USERS: 'Referred users',
    POINTS: 'Points',
    MANAGEMENT: 'Management',
    ADMIN_DASHBOARD: 'Admin Dashboard',
  },
  NAV: {
    COURSES: 'Courses',
    ONLINE_TESTS: 'Online Tests',
    AI_GENERATED_CONTENT: 'AI Generated Content',
    EXAMPLE_PRACTICES: 'Example Practices',
    USERS: 'Users',
    SANDBOX: 'Sandbox',
    BLOGS: 'Blog',
    WEBINARS: 'Webinars',
    RESOURCES: 'Resources',
    CERTIFICATE_CONFIG: 'Certificates',
    HALL_OF_FAME: 'Hall of Fame',
    SURVEYS: 'Surveys',
    VOUCHERS: 'Vouchers',
    JOBS: 'Jobs',
    COMPANIES: 'Hiring companies',
    ANNOUNCEMENTS: 'Announcements',
    EMOJI: 'Emoji',
    CREDIT_POINTS: 'Credit Points',
    NOTIFICATION_CONFIG: 'Notification config',
    SETTINGS: 'Settings',
    SUPPORT: 'Support',
    BLOG_MANAGEMENT: 'Blog management',
  },
  ADMIN: {
    COURSES_TITLE: 'Courses',
    COURSES_DESC: 'Manage and organize courses across the platform',
    COURSES_SEO: 'Admin Courses',
    USERS_TITLE: 'Users',
    USERS_DESC: 'View and manage users across the platform',
    USERS_SEO: 'Admin Users',
    WEBINARS_TITLE: 'Webinars',
    WEBINARS_DESC: 'View and manage webinars across the platform',
    WEBINARS_SEO: 'Admin Webinars',
    HALL_OF_FAME_TITLE: 'Hall of Fame',
    HALL_OF_FAME_DESC: 'View and manage student projects',
    HALL_OF_FAME_SEO: 'Admin Hall of Fame',
    SURVEYS_TITLE: 'Surveys',
    SURVEYS_DESC: 'View survey responses across the platform',
    SURVEYS_SEO: 'Admin Surveys',
    VOUCHERS_TITLE: 'Vouchers',
    VOUCHERS_DESC: 'View and manage vouchers across the platform',
    VOUCHERS_SEO: 'Voucher management',
    COMPANIES_TITLE: 'Companies',
    COMPANIES_DESC: 'View and manage companies across the platform',
    COMPANIES_SEO: 'Company Management',
    JOBS_TITLE: 'Jobs',
    JOBS_DESC: 'View and manage job postings across the platform',
    JOBS_SEO: 'Job Management',
    ANNOUNCEMENTS_TITLE: 'Announcements',
    ANNOUNCEMENTS_DESC: 'Send web or email notifications to all users, by role, or by class',
    ANNOUNCEMENTS_SEO: 'Admin Announcements',
    AI_CONTENT_TITLE: 'AI Generated Content',
    AI_CONTENT_DESC: 'Generated slides and documents hub',
    AI_CONTENT_SEO: 'AI Generated Content',
    RESOURCES_TITLE: 'Resources',
    RESOURCES_DESC: 'Upload and organize learning resources',
    RESOURCES_SEO: 'Resource management',
    SANDBOXES_TITLE: 'Sandbox',
    SANDBOXES_DESC: 'View and manage sandboxes across the platform',
    SANDBOXES_SEO: 'Admin Sandboxes',
    CREDIT_POINTS_TITLE: 'Credit Points',
    CREDIT_POINTS_DESC: 'View and manage credit points across the platform',
    CREDIT_POINTS_SEO: 'Credit Points',
    CREDIT_POINTS_ANALYTICS_TITLE: 'Credit points analytics',
    CREDIT_POINTS_ANALYTICS_DESC: 'View overview, top users, and redemption history',
    MEDIA_DEFAULTS_TITLE: 'Default media',
    MEDIA_DEFAULTS_DESC:
      'View and manage community branding, media, social links, and email sender defaults',
    MEDIA_DEFAULTS_SEO: 'Default Media',
    EMOJI_TITLE: 'Emoji',
    EMOJI_DESC: 'Manage custom emoji for the platform',
    EMOJI_SEO: 'Admin Emoji',
    CERTIFICATE_TITLE: 'Certificates',
    CERTIFICATE_DESC: 'Configure certificate templates for your community',
    CERTIFICATE_SEO: 'Certificate config',
    NOTIFICATION_CONFIG_TITLE: 'Notification config',
    NOTIFICATION_CONFIG_DESC: 'Configure notification templates and channels',
    NOTIFICATION_CONFIG_SEO: 'Notification config',
    ONLINE_TESTS_TITLE: 'Online Tests',
    ONLINE_TESTS_DESC: 'Create and manage online tests',
    ONLINE_TESTS_SEO: 'Admin Online Tests',
    EXAMPLE_PRACTICES_TITLE: 'Example Practices',
    EXAMPLE_PRACTICES_DESC: 'Manage example practice posts',
    EXAMPLE_PRACTICES_SEO: 'Admin Example Practices',
    BLOGS_TITLE: 'Blogs',
    BLOGS_DESC: 'View and manage blogs across the platform',
    BLOGS_SEO: 'Admin Blogs',
    ALL: 'All',
    PUBLISH: 'Publish',
    DRAFT: 'Draft',
    MESSAGES: 'Messages',
    EXPAND_SIDEBAR: 'Expand sidebar',
    COLLAPSE_SIDEBAR: 'Collapse sidebar',
    RESIZE_SIDEBAR: 'Resize sidebar',
    DRAG_TO_RESIZE: 'Drag to resize',
    OPEN_MENU: 'Open menu',
    SEARCHING: 'Searching...',
    TITLE: 'Title',
    UPLOAD_DATE: 'Upload date',
    DOWNLOAD: 'Download',
    ACTIONS: 'Actions',
    NO_DATA: 'No data found',
    UPLOAD_OR_CREATE_FOLDER: 'Upload a file or create a folder to get started',
    ADJUST_SEARCH_OR_FOLDER: 'Try adjusting your search or browse another folder',
    CREATE_COURSE_TO_UPLOAD: 'Please create a course to start uploading resources',
    ALLOWED: 'Allowed',
    RESTRICTED: 'Restricted',
    DELETE_RESOURCE_TITLE: 'Delete this resource?',
    DELETE_RESOURCE_DESC: 'This resource will be permanently removed.\nThis action cannot be undone',
    RESOURCE_DELETED: 'Resource deleted successfully',
    DELETE_FAILED: 'Delete failed',
    COPY_SUCCESS: 'Copied successfully',
    COPY_FAILED: 'Copy failed',
    COPY_FAILED_DESC: 'Could not copy the link. Please try again.',
    TRY_ADJUST_SEARCH: 'Try adjusting your search',
    CREATE_USER: 'Create new user',
    USER_DETAIL: 'User detail',
    USER_DETAIL_SUBTITLE: 'View and manage users across the platform',
    BACK_TO_USERS: 'Back to users',
  },
  PRICING: {
    TITLE: 'Pricing',
    SUBTITLE: 'Choose the perfect plan for your journey For Individuals',
    ANNUAL: 'Annual',
    STUDENT_PLAN: {
      TITLE: 'Student Plan',
      PRICE: '£39',
      DESCRIPTION: 'Everything you need to excel in your studies and research',
      FEATURES: {
        UNLIMITED_ACCESS: 'Unlimited access to all resources',
        RESEARCH_TOOLS: 'Advanced research tools',
        COLLABORATION: 'Collaboration features',
        PRIORITY_SUPPORT: 'Priority support',
        UPDATES: 'Regular updates and new content',
        MOBILE_ACCESS: 'Mobile app access',
      },
    },
  },
  HALL_OF_FAME: {
    DESCRIPTION:
      'A platform to mark our students progress, preserving their proud achievements, attractive offers, and passionate projects.',
    ALL: 'All',
    FILTER_BY: 'Filter by',
    NO_PROJECT_FOUND: 'No projects found',
    NO_PROJECT_FOUND_TEXT_1: 'No projects were found in [Index]. Please select the others.',
    NO_PROJECT_FOUND_TEXT_2: 'There are no projects at the moment. Please comeback later',
    VIEW_DETAILS: 'View details',
  },
  BLOG: {
    TITLE: 'Blog',
    DESCRIPTION: 'Always updated with the latest news, technology trends, in-depth knowledge, and quality lectures.',
  },
  RESOURCE: {
    ERROR: 'You cannot access this resource',
    HEADING: 'Resource management',
    UPLOAD: 'Upload',
    CREATE_FOLDER: 'Create folder',
  },
  TABLE: {
    TOTAL: 'Total',
    ALL: 'All',
  },
  COMMON: {
    HOME: 'Home',
    LOADING: 'Loading...',
    CANCEL: 'Cancel',
    DETAILS: 'Details',
    START: 'Start',
    REVIEW: 'Review',
    BREADCRUMB: 'Breadcrumb',
    MINUTES: 'minutes',
    MINUTES_SHORT: 'min',
    NO_DESCRIPTION: 'No description provided.',
    OF: 'of',
    SAVE: 'Save',
    DELETE: 'Delete',
    CLOSE: 'Close',
    CONFIRM: 'Confirm',
    YES: 'Yes',
    NO: 'No',
    SEARCH: 'Search',
  },
  ONLINE_TEST: {
    TITLE: 'Online Tests',
    SUBTITLE: 'Browse public tests or view tests assigned to you.',
    PUBLIC_TAB: 'Public',
    MY_TESTS_TAB: 'My tests',
    PUBLIC_BADGE: 'Public',
    PUBLIC_EMPTY_TITLE: 'No public tests yet',
    PUBLIC_EMPTY_DESCRIPTION: 'Published public tests will appear here for everyone to discover and take.',
    TAKE_TEST: 'Take test',
    PUBLIC_SIGN_IN_TITLE: 'Sign in to take the test',
    PUBLIC_SIGN_IN_DESCRIPTION: 'You need to sign in before you can start this test.',
    MY_TESTS_SIGN_IN_TITLE: 'Sign in to view assigned tests',
    MY_TESTS_SIGN_IN_DESCRIPTION: 'Your instructor-assigned tests appear here after you sign in.',
    UNABLE_TO_LOAD: 'Unable to load tests.',
    UNABLE_TO_START: 'Unable to start test',
    UNABLE_TO_SUBMIT: 'Unable to submit test',
    UNABLE_TO_LOAD_ATTEMPT: 'Unable to load test attempt.',
    UNABLE_TO_LOAD_REVIEW: 'Unable to load test review.',
    TEST_UNAVAILABLE: 'Test unavailable',
    TEST_NOT_AVAILABLE: 'Test Not Available',
    TEST_UNAVAILABLE_HINT: 'If you believe this is an error, please contact your instructor or administrator.',
    BACK_TO_MY_TESTS: 'Back to my tests',
    BACK_TO_TEST: 'Back to test',
    ATTEMPT_UNAVAILABLE: 'Attempt unavailable',
    UNABLE_TO_LOAD_ATTEMPT_TITLE: 'Unable to Load Attempt',
    REVIEW_UNAVAILABLE: 'Review unavailable',
    UNABLE_TO_LOAD_REVIEW_TITLE: 'Unable to Load Review',
    NO_ACCESS: 'You do not have access to this test.',
    LOAD_ERROR: 'Something went wrong loading this test.',
    UNLIMITED_ATTEMPTS: 'Unlimited attempts',
    NO_ATTEMPTS_LEFT: 'No attempts left',
    ATTEMPTS_LEFT: (remaining: number, limit: number) => `${remaining} of ${limit} left`,
    EMPTY_TITLE: 'No tests assigned yet',
    EMPTY_DESCRIPTION:
      'When your instructor assigns an online test, it will appear here. Check back later or contact your instructor.',
    TIME_LIMIT: 'Time limit',
    CONTENT: 'Content',
    OPEN_TOC: 'Table of contents',
    PASSING_SCORE: 'Passing score',
    ATTEMPTS: 'Attempts',
    UNLIMITED: 'Unlimited',
    ATTEMPTS_USED: (completed: number, limit: number) => `${completed}/${limit} used`,
    ALL_ATTEMPTS_USED: 'All attempts used',
    ALL_ATTEMPTS_USED_DESC: (limit: number) =>
      `You have completed all ${limit} allowed attempt${limit > 1 ? 's' : ''} for this test. Review your results below.`,
    STARTING: 'Starting…',
    NO_ATTEMPTS_REMAINING: 'No attempts remaining',
    START_NEW_ATTEMPT: 'Start New Attempt',
    START_NOW: 'Start Now',
    ATTEMPT_HISTORY: 'Attempt History',
    NO_ATTEMPTS_YET: 'No attempts yet',
    NO_ATTEMPTS_YET_DESC: 'Start your first attempt to see results here.',
    START_TEST_TITLE: 'Start Test?',
    START_TEST_INTRO: (title: string) => `You are about to start ${title}. Please review the test conditions:`,
    START_TEST_TIME_LIMIT: (minutes: number) => `Time limit: ${minutes} minutes`,
    START_TEST_PASSING_SCORE: (score: string) => `Passing score: ${score}`,
    START_TEST_ATTEMPT: (current: number, limit?: number) =>
      limit ? `Attempt: ${current} of ${limit}` : `Attempt: ${current}`,
    START_TEST_TAB_WARNING: 'Switching tabs may be recorded as a violation',
    START_TEST_TIMER_NOTE:
      'The timer starts immediately. Make sure you have a stable connection and can complete the test without interruptions.',
    ACCESS_AVAILABLE: 'Available',
    ACCESS_CLOSED: 'Closed',
    ACCESS_FROM: (date: string) => `Available from ${date}`,
    SCORE: 'Score',
    INTEGRITY_VIOLATION: 'Integrity violation',
    IN_PROGRESS_RESUME: 'In progress — click to resume',
    PASS: 'Pass',
    FAIL: 'Fail',
    IN_PROGRESS: 'In progress',
    REVIEW_TITLE_SUFFIX: 'Review',
    REVIEW_SEO_TITLE: (title: string) => `${title} Review`,
    PROCTORING_FAILED_TITLE: 'Attempt failed due to test integrity violation.',
    PROCTORING_FAILED_DESC: (count: number, limit: number) => `Recorded violations: ${count}/${limit}.`,
    QUESTION_REVIEW: 'Question Review',
    QUESTIONS_CORRECT: (correct: number, total: number) => `${correct} of ${total} questions answered correctly`,
    QUESTION_PAGES: 'Question Pages',
    PAGE_RANGE: (page: number, start: number, end: number) => `Page ${page}: Q${start}–Q${end}`,
    SHOWING_QUESTIONS: (start: number, end: number, total: number) =>
      `Showing questions ${start}–${end} of ${total}`,
    CORRECT: 'Correct',
    SELECTED: 'Selected',
    YOUR_ANSWER: 'Your answer',
    CORRECT_ANSWER: 'Correct answer',
    SLOT_NOT_ANSWERED: 'Not answered',
    YOUR_CORRECT_ANSWERS: 'Your correct answer(s):',
    YOUR_WRONG_ANSWERS: 'Your wrong answer(s):',
    NO_ANSWER_SELECTED: 'You did not answer this question',
    EXPLANATION: 'Explanation',
    NAV_PENDING_COUNT: (count: number) => `Online Tests (${count})`,
    // Test taker
    TAB_SWITCH_TITLE: 'Tab switch recorded',
    TAB_SWITCH_DESC: (warning: number, limit: number) =>
      `Warning ${warning}/${limit}. Leaving the test tab again will submit and fail this attempt.`,
    TEST_SUBMITTED_TITLE: 'Test submitted',
    TEST_SUBMITTED_DESC: 'This attempt was submitted due to a test integrity violation. Redirecting to results…',
    QUESTION_OF: (current: number, total: number) => `Question ${current} of ${total}`,
    MULTIPLE_SELECT: 'Multiple Select',
    SINGLE_CHOICE: 'Single Choice',
    CHOOSE_MULTIPLE: 'Choose one or more answers',
    READING_PASSAGE: 'Reading passage',
    DROP_OR_SELECT_ANSWER: 'Drop or Select your answer',
    TYPE_OR_SELECT_ANSWER: 'Type or select',
    TYPE_ANSWER: 'Type your answer',
    SELECT_ANSWER: 'Select answer',
    DRAG_OPTION_INTO_QUESTION: 'Drag option into question',
    OPTIONS_COUNT: (count: number) => `${count} options`,
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    REVIEW_AND_SUBMIT: 'Review & Submit',
    QUESTIONS: 'Questions',
    ALL_QUESTIONS: 'All Questions',
    ANSWERED_OF: (answered: number, total: number) => `${answered} of ${total} answered`,
    SUBMIT: 'Submit',
    DONE: 'done',
    ANSWER_SAVE_FAILED: 'Answer save failed',
    ANSWER_SAVE_FAILED_DESC: 'Retry before final submit.',
    RESOLVE_SAVE_FAILURES: 'Resolve save failures before submitting',
    // Submit modal
    SUBMIT_TEST_TITLE: 'Submit Test?',
    SUBMIT_TEST_DESC: 'Review your progress before submitting. This action cannot be undone.',
    ANSWERED: 'Answered',
    UNANSWERED: 'Unanswered',
    FLAGGED: 'Flagged',
    REMAINING: 'Remaining',
    UNANSWERED_QUESTIONS: 'Unanswered questions:',
    MORE_UNANSWERED: (count: number) => `+${count} more`,
    CONTINUE_TEST: 'Continue Test',
    SUBMITTING: 'Submitting…',
    SUBMIT_TEST: 'Submit Test',
    // Question navigator
    PROGRESS: 'Progress',
    CURRENT: 'Current',
    UNFLAG_QUESTION: 'Unflag question',
    FLAG_FOR_REVIEW: 'Flag for review',
    REVIEW_SUBMIT_LEFT: (count: number) => `Review & Submit (${count} left)`,
    // Score hero
    FAILED_INTEGRITY: 'Failed — Integrity Violation',
    PASSED: 'Passed',
    FAILED: 'Failed',
    INCORRECT: 'Incorrect',
    SCORE_SUMMARY: (correct: number, total: number) =>
      `${correct} out of ${total} questions answered correctly`,
  },
  EXAMPLE_PRACTICE: {
    TITLE: 'Example Practice',
    DESCRIPTION:
      'Explore sample posts with detailed examples, translations, and exercises to support your learning.',
    SEO_DESCRIPTION:
      'Browse example practice posts with sample answers, vocabulary, and exercises.',
    SEO_SECTION: 'Example Practice',
    SEARCH: 'Search',
    SEARCH_PLACEHOLDER: 'Search posts...',
    CATEGORY: 'Category',
    ALL_CATEGORIES: 'All categories',
    YEAR: 'Year',
    ALL_YEARS: 'All years',
    ORDER_BY: 'Order by',
    SORT_BY: 'Sort by',
    NEWEST_FIRST: 'Newest first',
    OLDEST_FIRST: 'Oldest first',
    MOST_VIEWS: 'Most views',
    NO_POSTS: 'No example practice posts found.',
    MIN_READ: (minutes: number) => `${minutes} min read`,
    VIEWS: (count: string) => `${count} views`,
    SHARE_DESCRIPTION: (siteName: string) => `Read this example practice on ${siteName}`,
    OPEN_TOC: 'Open Table of Contents',
  },
  AUTH: {
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    EMAIL: 'Email',
    PASSWORD: 'Password',
    CONFIRM_PASSWORD: 'Confirm Password',
    OR_CONTINUE_WITH: 'Or continue with',
    CREATE_ACCOUNT: 'Create Account',
    SIGN_UP_SUCCESS: 'Sign up successful!',
    SIGN_UP_ERROR: 'Sign up error',
    SOMETHING_WRONG: 'Uh oh! Something went wrong.',
    USE_DIFFERENT_EMAIL: 'Use a different email',
  },
}

export default en
